/** Shared empty/inconclusive-state presentation, e.g. no causal seam found, no variants run. Never blank space. */
export function EmptyState({ title, detail }: { title: string; detail?: string }) {
  return (
    <div className="rounded border border-dashed border-rule-strong px-6 py-8 text-center">
      <p className="text-sm text-ink">{title}</p>
      {detail && <p className="mt-2 text-sm text-ink-muted">{detail}</p>}
    </div>
  );
}
